// Copyright (c) 2016 Deere & Company

import {isNotEmpty, isNotNull, isRepairDateAfterFailureDate} from '../../shared/services/claim-shared-helper';
import AttachmentClaim from '@deere/cps-it.warranty-model-factory/lib/claim-attachment';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';

const hasAtLeastOneClaimItem = claim => claim.parts.length || claim.labor.length || claim.otherCredits.length;

const hasComplaintCauseCorrection = complaintCauseCorrection => [
    isNotEmpty(complaintCauseCorrection.causeOfComplaining),
    isNotEmpty(complaintCauseCorrection.howWasComplaintCorrected),
    isNotEmpty(complaintCauseCorrection.operatorsComplaint)
].every(rule => rule);

const isComplaintCauseCorrectionValid = (installedBy, complaintCauseCorrection) => installedBy === 'R' ?
    isNotEmpty(complaintCauseCorrection.causeOfComplaining) :
    hasComplaintCauseCorrection(complaintCauseCorrection);

export const canShowAllSections = (claimNumber, isValidClaim) => isValidClaim || isNotEmpty(claimNumber);

export const isValidClaim = claim => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.referenceInfo.ownershipStatus.key),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNotEmpty(claim.itemNumber),
    isNotEmpty(claim.previousInvoiceNumber),
    claim.retailInstallDate !== null,
    claim.failureInfo.repairDate !== null,
    claim.failureInfo.failureDate !== null,
    isRepairDateAfterFailureDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate)
].every(rule => rule);

export const saveValidate = claim => [
    isValidClaim(claim),
    isNotEmpty(claim.additionalFailureInfo.failureMode.key),
    isNotEmpty(claim.additionalFailureInfo.failureArea),
    isNotEmpty(claim.additionalFailureInfo.downtime.key),
    isComplaintCauseCorrectionValid(claim.installedBy.key, claim.complaintCauseCommentsBasis),
    hasAtLeastOneClaimItem(removeEmptyRows(claim, AttachmentClaim))
].every(rule => rule);

export const mapFormValidation = (property, value) => {

    const map = {
        application: isNotEmpty,
        complaintCause: isNotEmpty,
        complaintCorrection: isNotEmpty,
        downtime: isNotEmpty,
        failureArea: isNotEmpty,
        failureDate: isNotNull,
        failureMode: isNotEmpty,
        failurePart: isNotEmpty,
        installedBy: isNotEmpty,
        itemNumber: isNotEmpty,
        model: isNotEmpty,
        operatorsComplaint: isNotEmpty,
        ownershipStatus: isNotEmpty,
        pin: isNotEmpty,
        previousInvoiceNumber: isNotEmpty,
        repairDate: isNotNull,
        repairNumber: isNotEmpty,
        responsibleAccount: isNotEmpty,
        retailInstallDate: isNotNull,
        serialNumber: isNotEmpty,
        useAmount: isNotEmpty,
        useAmountUnit: isNotEmpty,
        workOrderOne: isNotEmpty
    };

    return map[property](value);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) => selectedAction === 'VALIDATE' ?
!validationFailed && !currentPageValidity :
    false;



// WEBPACK FOOTER //
// ./src/claim/attachment/services/claim-validation-helper.js